import { render, staticRenderFns } from "./postDetail.vue?vue&type=template&id=767db3aa&scoped=true&"
import script from "./postDetail.vue?vue&type=script&lang=js&"
export * from "./postDetail.vue?vue&type=script&lang=js&"
import style0 from "./postDetail.vue?vue&type=style&index=0&id=767db3aa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "767db3aa",
  null
  
)

export default component.exports